import { fetchUtils } from "react-admin";
import { stringify } from "query-string";
import { GET_ONE, UPDATE } from "react-admin";
import Resizer from "react-image-file-resizer";
import fakeBookings from "../Booking/Components/fakeBookings";
import fakeCustomers from "../Enterprise/Customer/components/fakeCustomers";
import fakeIncome from "./datafakes/fakeIncomeBalance";
import fakeExpense from "./datafakes/fakeExpenseBalance";
import fakeCoupon from "./datafakes/fakeCoupon";
import { useContext } from "react";
import { OnboardingContext } from "../contexts/OnboardingContext";

const apiUrl = process.env.REACT_APP_API_URL;
const httpClient = (url, options = {}) => {
  const token = localStorage.getItem("token");
  options.user = {
    authenticated: true,
    token: "Bearer " + token,
  };

  return fetchUtils
    .fetchJson(url, options)
    .then(({ headers, json }) => {
      return { headers, json };
    })
    .catch((error) => {
      console.error("Error en la solicitud:", error);
      throw error;
    });
};

export const getResizedImage = (file, max, format) =>
  new Promise((resolve) => {
    return Resizer.imageFileResizer(
      file,
      max,
      max,
      format,
      90,
      0,
      (blob) => {
        return resolve(blob);
      },
      "blob"
    );
  });

let providerCache = null; // almacena el objeto provider
let providerPromise = null; // evita duplicar requests en paralelo

const getCachedProvider = async () => {
  // 1) Si ya lo tenemos, lo devolvemos al instante
  if (providerCache) return providerCache;

  // 2) Si ya está en proceso otra llamada, esperamos a esa misma promesa
  if (providerPromise) return providerPromise;

  // 3) Primera vez: disparamos la llamada y guardamos la PROMESA
  providerPromise = (async () => {
    try {
      const profile = JSON.parse(localStorage.getItem("profile"));
      const providerId = profile?.role === "admin-sucursal" ? profile?.employer?._id : profile?._id;

      if (!providerId) {
        console.warn("No hay providerId en profile"); // opcional
        return null;
      }

      const { json } = await httpClient(`${apiUrl}/providers/${providerId}`);
      // Guarda el provider en caché para futuras llamadas
      providerCache = json.data ?? json;
      return providerCache;
    } catch (err) {
      console.error("Error al obtener provider:", err);
      return null; // evita romper el flujo
    } finally {
      providerPromise = null; // limpia la promesa en vuelo
    }
  })();

  return providerPromise;
};
// Llama al endpoint de IA para generar servicios a partir de imágenes
export const generateServicesWithIA = async (imageFiles) => {
  const formData = new FormData();
  imageFiles.forEach((file) => {
    formData.append("images", file);
  });
  const token = localStorage.getItem("token");
  const response = await fetch(`${apiUrl}/service/ia/generate`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: formData,
  });
  if (!response.ok) {
    throw new Error("Error al generar servicios con IA");
  }
  const json = await response.json();
  return json.data;
};

// Llama al endpoint de IA para generar servicios a partir de archivos (PDF, Word, Excel)
export const generateServicesWithIAFromFiles = async (files) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files", file);
  });
  const token = localStorage.getItem("token");

  // Crear un AbortController con timeout extendido
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 600000); // 10 minutos

  try {
    const response = await fetch(`${apiUrl}/service/ia/generate-from-files`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: formData,
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error("Error al generar servicios con IA desde archivos");
    }

    const json = await response.json();
    return json.data;
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === "AbortError") {
      throw new Error("El procesamiento tardó demasiado tiempo. Intenta con archivos más pequeños.");
    }
    throw error;
  }
};
// Crea servicios de forma masiva
export const bulkCreateServices = async ({ services, provider, category, subCategory, package: pkg, pinned }) => {
  const token = localStorage.getItem("token");
  const apiUrl = process.env.REACT_APP_API_URL;
  const response = await fetch(`${apiUrl}/service/bulk`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ services, provider, category, subCategory, package: pkg, pinned }),
  });
  if (!response.ok) {
    throw new Error("Error al crear servicios masivos");
  }
  const json = await response.json();
  return json.data;
};
// Sube una imagen al endpoint /service/upload-image y retorna la URL generada
export const uploadImageToUrl = async (file) => {
  const formData = new FormData();
  formData.append("image", file);
  const token = localStorage.getItem("token");
  const response = await fetch(`${apiUrl}/service/upload-image`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: formData,
  });
  if (!response.ok) {
    throw new Error("Error al subir imagen");
  }
  const json = await response.json();
  return json?.url || json;
};

// Obtiene los servicios disponibles de un empleado
export const getEmployeeAvailableServices = async (employeeId) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${apiUrl}/employee/${employeeId}/services`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  if (!response.ok) {
    throw new Error("Error al cargar servicios del empleado");
  }
  const json = await response.json();
  return json.data;
};
const getFakeDataIfFreemium = async (resource) => {
  const provider = await getCachedProvider();
  const plan = provider?.plan;

  const moduleAccessByPlan = {
    "enterprise/customers": ["standard", "franquicia", "enterprise"],
    booking: ["standard", "franquicia", "enterprise"],
    "booking/balance": ["standard", "franquicia", "enterprise"],
    "transaction/provider/income": ["standard", "franquicia", "enterprise"],
    "transaction/provider/expense": ["standard", "franquicia", "enterprise"],
    coupon: ["enterprise"],
  };

  if (!Object.keys(moduleAccessByPlan).includes(resource)) return null;

  const allowedPlans = moduleAccessByPlan[resource];
  if (allowedPlans.includes(plan)) return null;
  if (resource === "enterprise/customers" && window.location.hash.includes("/booking/create")) {
    return null;
  }
  switch (resource) {
    case "enterprise/customers":
      return {
        data: fakeCustomers.map((c) => ({ ...c, id: c.id || c._id || String(c.phone) })), // asegura que tengan ID
        total: fakeCustomers.length,
      };

    case "booking":
      return {
        data: fakeBookings.map((b) => ({ ...b, id: b._id })),
        total: fakeBookings.length,
      };
    case "booking/balance":
      return {
        data: fakeBookings.map((b) => ({ ...b, id: b._id })),
        total: fakeBookings.length,
        totalAmount: 1080,
        totalFeeAmount: fakeBookings.totalFeeAmount ?? 0,
        totalFeeAmountEmployee: fakeBookings.totalFeeAmountEmployee ?? 0,
      };
    case "transaction/provider/income":
      return {
        data: fakeIncome.map((b) => ({ ...b, id: b._id })),
        total: fakeIncome.length,
        totalAmount: 525,
      };
    case "transaction/provider/expense":
      return {
        data: fakeExpense.map((b) => ({ ...b, id: b._id })),
        total: fakeIncome.length,
        totalAmount: 915,
      };
    case "coupon":
      return {
        data: fakeCoupon.map((c) => ({ ...c, id: c.id || c._id })),
        total: fakeCoupon.length,
      };
    default:
      return null;
  }
};

const getList = async (resource, params = {}) => {
  const fakeData = await getFakeDataIfFreemium(resource);
  if (fakeData) return fakeData;
  let query = params?.filter ?? {};
  const flattenFilters = (obj, prefix = "") =>
    Object.keys(obj).reduce(
      (acc, key) => {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          Object.entries(obj[key]).forEach(([subKey, value]) => {
            acc[`${key}.${subKey}`] = value;
          });
          delete acc[key];
        } else {
          acc[key] = obj[key];
        }
        return acc;
      },
      { ...obj }
    );

  query = flattenFilters(query);

  const { pagination, sort } = params;
  query.page = pagination?.page ?? null;
  query.perPage = pagination?.perPage ?? null;
  query.sort = (sort?.order === "DESC" ? "-" : "") + sort?.field;
  if (query.provider?.name) {
    query["provider.name"] = query.provider.name;
    delete query.provider;
  }

  const url = `${apiUrl}/${resource}?${stringify(query)}`;
  return httpClient(url, {
    method: "GET",
  }).then(({ headers, json }) => {
    const data = json.data;
    return {
      data: Array.isArray(data)
        ? data.map((e) => {
            // Preservar el id si ya existe, sino usar _id
            e.id = e.id || e._id;
            return e;
          })
        : [{ ...data, id: 1 }],
      total: json.totalDocs ?? 1,
      totalPages: json.totalPages, // Total de páginas disponibles
      totalDocs: json.totalDocs, // Total de documentos encontrados
      // limit: json.limit, // Límite de elementos por página
      page: json.page, // Página actual
      hasNextPage: json.hasNextPage, // ¿Hay página siguiente?
      hasPrevPage: json.hasPrevPage, // ¿Hay página anterior?
      nextPage: json.nextPage, // Número de la siguiente página
      prevPage: json.prevPage, // Número de la página anterior
      totalAmount: json.totalAmount ?? 0,
      totalFeeAmount: json.totalFeeAmount ?? 0,
      totalFeeAmountEmployee: json.totalFeeAmountEmployee ?? 0,
    };
  });
};

// Actualiza el paso de onboarding del usuario
export const updateOnboardingStep = async (
  { userId, step },
  { setOnboardingSteps, checkAndTriggerOnboarding, refetch, onboardingSteps }
) => {
  if (onboardingSteps.includes(step)) {
    // Ya está completado, no hacer nada
    return;
  }
  const token = localStorage.getItem("token");
  const response = await fetch(`${apiUrl}/user/onboarding-step`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ userId, step }),
  });
  const data = await response.json();
  if (response.ok) {
    setOnboardingSteps(data.data ?? []);
    checkAndTriggerOnboarding(step);
    if (typeof refetch === "function") refetch();
  } else {
    throw new Error(data.message || "Error desconocido");
  }
  return data;
};

// Actualiza el status de la suscripción del usuario
export const updateSubscriptionStatus = async ({ userId, status }) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${apiUrl}/subscription/status`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userId, status }),
  });

  if (!response.ok) {
    throw new Error("Error actualizando el status de suscripción");
  }

  return await response.json();
};

const getOne = (resource, params) => {
  return httpClient(`${apiUrl}/${resource}/${params.id}`).then(({ json }) => {
    return {
      data: {
        ...(json.data ?? json),
        id: params.id ?? json._id ?? json.data?._id,
      },
    };
  });
};

const getMany = (resource, params) => {
  const query = {
    filter: JSON.stringify({ id: params.ids }),
  };
  const url = `${apiUrl}/${resource}`;
  return httpClient(url).then(({ json }) => {
    return {
      data: json.data.map((e) => {
        e.id = e._id;
        return e;
      }),
    };
  });
};

const create = (resource, params) => {
  return httpClient(`${apiUrl}/${resource}`, {
    method: "POST",
    body: JSON.stringify(params.data),
  })
    .then(({ json }) => {
      if (json.error) {
        return Promise.reject(json.error);
      }
      return {
        data: {
          ...params.data,
          id: json.data?._id || json._id,
          ...json,
        },
      };
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

const createMany = async (resource, params) => {
  try {
    const response = await httpClient(`${apiUrl}/${resource}/bulk`, {
      method: "POST",
      body: JSON.stringify(params.data),
    });

    return {
      data: response.json.map((record) => ({ ...record, id: record._id })),
    };
  } catch (error) {
    throw new Error(error.message || "Error al crear registros");
  }
};

export const createDataForm = async (resource, dataWithFile) => {
  return await httpClient(`${apiUrl}/${resource}`, {
    method: "POST",
    mode: "cors",
    body: dataWithFile,
  })
    .then(({ json }) => {
      if (json.error) {
        return Promise.reject(json.error);
      }
      json.data.id = json.data._id;
      return {
        data: json.data,
      };
    })
    .catch((error) => Promise.reject(error));
};

const objectToFormData = (object) =>
  Object.keys(object)?.reduce((formData, key) => {
    const value = typeof object[key] === "object" && object[key] !== null ? JSON.stringify(object[key]) : object[key];
    formData.append(key, value);
    return formData;
  }, new FormData());
//este es el enpoitn  a tomar
const update = (resource, params) => {
  const baseUrl = `${apiUrl}/${resource}/${params.id ?? ""}${
    params.meta?.customAction ? "/" + params.meta.customAction : ""
  }`;
  return httpClient(baseUrl, {
    method: "PUT",
    body: JSON.stringify(params.data),
  })
    .then(({ json }) => {
      if (json.error) {
        return Promise.reject(json.error);
      }
      return { data: { ...json.data, id: json.data?._id ?? json._id } };
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

const updateDataForm = (resource, dataWithFile, id) => {
  return httpClient(`${apiUrl}/${resource}/${id}`, {
    method: "PUT",
    mode: "cors",
    body: dataWithFile,
  }).then(({ json }) => ({ data: { ...json.data, id: json.data._id } }));
};

const _delete = (resource, params) => {
  let url = `${apiUrl}/${resource}/${params.id}`;

  // Para paquetes, agregar providerId como query parameter
  if (resource === "package" && params.meta?.providerId) {
    url += `?providerId=${params.meta.providerId}`;
  }

  return httpClient(url, {
    method: "DELETE",
  }).then(({ json }) => ({ data: json.data }));
};

const handler = async (verb, resource, params) => {
  if (resource === "categories") {
    if (verb === "CREATE") {
      const dataWithFile = new FormData();
      dataWithFile.append("name", params.data.name);
      dataWithFile.append("type", params.data.type);
      dataWithFile.append(
        "logo",
        await getResizedImage(params.data.logo.rawFile, 200, "PNG")
          .then((mediaFile) => {
            return mediaFile;
          })
          .catch((e) => {})
      );

      const resultArray = await Promise.all(
        params.data.subCategory.map(async (e) => {
          if (e.name && e.logo) {
            dataWithFile.append("subCategory.name", e.name);
            const resizedImg = await getResizedImage(e.logo.rawFile, 400, "PNG")
              .then((mediaFile) => {
                return mediaFile;
              })
              .catch((e) => {});
            dataWithFile.append("subCategory.logo", await resizedImg);
          } else {
            Promise.reject("Debes llenar todos los campos de la subcategoría");
          }
        })
      );
      return await createDataForm(resource, dataWithFile);
    }
    if (verb === "UPDATE") {
      const dataWithFile = new FormData();
      dataWithFile.append("name", params.data.name);
      dataWithFile.append("state", params.data.state);
      dataWithFile.append(
        "logo",
        await getResizedImage(params.data.logo.rawFile, 200, "PNG")
          .then((mediaFile) => {
            return mediaFile;
          })
          .catch((e) => {})
      );
      const resultArray = await Promise.all(
        params.data.subCategory.map(async (e) => {
          if (e.name) {
            dataWithFile.append("subCategory.name", e.name);
            dataWithFile.append("subCategory.state", e.state);
            if (typeof e.logo != "string") {
              dataWithFile.append(
                "subCategory.logo",
                await getResizedImage(e.logo.rawFile, 400, "PNG")
                  .then((mediaFile) => {
                    return mediaFile;
                  })
                  .catch((e) => {})
              );
              if (e._id) {
                dataWithFile.append("newLogo", e._id);
                dataWithFile.append("newLogo", "new");
              }
            } else {
            }
            delete e.logo;
          } else {
            Promise.reject("Debes llenar todos los campos de la subcategoría");
          }
        })
      );
      dataWithFile.append("subCategory", JSON.stringify(params.data.subCategory));
      return await updateDataForm(resource, dataWithFile, params.data.id);
    }
  }

  if (resource === "sos") {
    if (verb === "CREATE") {
      const dataWithFile = new FormData();
      dataWithFile.append("name", params.data.name);
      dataWithFile.append("phone", params.data.phone);
      dataWithFile.append("type", params.data.type);
      dataWithFile.append(
        "logo",
        await getResizedImage(params.data.logo.rawFile, 200, "PNG")
          .then((mediaFile) => {
            return mediaFile;
          })
          .catch((e) => {})
      );

      return await createDataForm(resource, dataWithFile);
    }
    if (verb === "UPDATE") {
      const dataWithFile = new FormData();
      dataWithFile.append("name", params.data.name);
      dataWithFile.append("state", params.data.state);
      dataWithFile.append("phone", params.data.phone);
      dataWithFile.append(
        "logo",
        await getResizedImage(params.data.logo.rawFile, 200, "PNG")
          .then((mediaFile) => {
            return mediaFile;
          })
          .catch((e) => {})
      );
      return await updateDataForm(resource, dataWithFile, params.data.id);
    }
  }

  if (resource === "product") {
    if (verb === "CREATE" || verb === "UPDATE") {
      const dataWithFile = objectToFormData(params.data);
      if (params.data.image?.rawFile) {
        dataWithFile.append("image", await getResizedImage(params.data.image.rawFile, 800, "JPEG"));
      }

      if (verb === "CREATE") {
        return await createDataForm(resource, dataWithFile);
      }

      if (verb === "UPDATE") {
        dataWithFile.delete("provider");
        return await updateDataForm(resource, dataWithFile, params.data.id);
      }
    }
  }

  if (resource === "profile") {
    if (verb === GET_ONE) {
      const storedProfile = localStorage.getItem("profile");

      if (storedProfile) {
        return Promise.resolve({
          data: { ...JSON.parse(storedProfile), id: params.id },
        });
      }
      // No profile yet, return a default one
      // It's important that we send the same id as requested in params
      // Indeed, react-admin will verify it and may throw an error if they are different
      // I don't have to do it when the profile exists as it will be included in the data stored in the local storage
      return Promise.resolve({
        data: { id: params.id, language: "es" },
      });
    }

    if (verb === UPDATE) {
      const dataWithFile = new FormData();

      dataWithFile.append("first_name", params.data.first_name);
      dataWithFile.append("business_name", params.data.business_name);
      dataWithFile.append("phone", params.data.phone);
      dataWithFile.append("CI_NIT", params.data.CI_NIT);
      dataWithFile.append("intervalMinutes", String(params.data.intervalMinutes ?? 30));

      // PaymentQR fields
      dataWithFile.append("isActive", params.data.paymentQR?.isActive ?? false);
      dataWithFile.append("message", params.data.paymentQR?.message ?? "QR PAGO - Reserva Confirmada");
      dataWithFile.append("messageFinished", params.data.paymentQR?.messageFinished ?? "QR PAGO - Servicio Finalizado");
      dataWithFile.append("sendImageConfirmed", params.data.paymentQR?.sendImageConfirmed ?? true);
      dataWithFile.append("sendImageFinished", params.data.paymentQR?.sendImageFinished ?? true);

      if (params.data.recommendedServices) {
        dataWithFile.append("recommendedServices", JSON.stringify(params.data.recommendedServices));
      }
      dataWithFile.append("availability", JSON.stringify(params.data.availability));
      if (params.data.picture?.rawFile?.type == "image/jpeg") {
        dataWithFile.append("picture", await getResizedImage(params.data.picture.rawFile, 800, "JPEG"));
      } else if (params.data.picture?.rawFile?.type == "image/png") {
        dataWithFile.append("picture", await getResizedImage(params.data.picture.rawFile, 800, "PNG"));
      }

      if (params.data.paymentQR?.image?.rawFile) {
        const type = params.data.paymentQR.image.rawFile.type;
        if (type === "image/jpeg") {
          dataWithFile.append("imageQR", await getResizedImage(params.data.paymentQR.image.rawFile, 800, "JPEG"));
        } else if (type === "image/png") {
          dataWithFile.append("imageQR", await getResizedImage(params.data.paymentQR.image.rawFile, 800, "PNG"));
        }
      }

      const profile = await updateDataForm("profile", dataWithFile, params.data._id);
      // window.location.reload();
      profile.data.id = profile.data._id;
      localStorage.setItem("profile", JSON.stringify(profile.data));
      return profile;
    }
  }

  if (resource === "employeesAll") {
    if (verb === "GET_LIST") {
      console.log(params);
      const { providerId, branchUrl, state } = params.filter || {};

      if (!providerId) {
        throw new Error("providerId es obligatorio");
      }

      const query = new URLSearchParams();
      if (branchUrl) {
        query.append("branchId", branchUrl);
      }

      if (state) {
        query.append("state", state);
      }
      console.log("query", query.toString());
      const url = `${apiUrl}/${resource}/${providerId}?${query.toString()}`;

      return httpClient(url).then(({ json }) => ({
        data: json.data.map((employee) => ({
          ...employee,
          id: employee._id,
        })),
        total: json.data.length,
      }));
    }
  }

  if (resource === "employee") {
    if (verb === "CREATE") {
      console.log(params);
      const dataWithFile = new FormData();
      dataWithFile.append("first_name", params.data.first_name);
      dataWithFile.append("last_name", params.data.last_name);
      dataWithFile.append("phone", params.data.phone);
      dataWithFile.append("CI_NIT", params.data.CI_NIT);
      dataWithFile.append("email", params.data.email);
      dataWithFile.append("password", params.data.password);
      if (params.data.branch) {
        dataWithFile.append("branch", JSON.stringify(params.data.branch));
      }
      dataWithFile.append("serviceMethod", params.data.serviceMethod);
      dataWithFile.append("state", true);

      // Imagen opcional - solo agregar si existe
      if (params.data.picture?.rawFile) {
        dataWithFile.append("picture", await getResizedImage(params.data.picture.rawFile, 800, "JPEG"));
      }

      if (params.data.deliveryVehicle) {
        dataWithFile.append("deliveryVehicle", params.data.deliveryVehicle);
      }

      if (params.data.availableServices) {
        dataWithFile.append("availableServices", JSON.stringify(params.data.availableServices));
      }

      if (params.data.servicesCommissions) {
        dataWithFile.append("servicesCommissiones", JSON.stringify(params.data.servicesCommissions));
      }

      if (params.data.availability) {
        dataWithFile.append("availability", JSON.stringify(params.data.availability));
      }

      // Agregar cobrarComision con valor por defecto true
      dataWithFile.append(
        "cobrarComision",
        params.data.cobrarComision !== undefined ? params.data.cobrarComision : true
      );

      return await createDataForm("employee", dataWithFile, params.data._id);
    }

    if (verb === UPDATE) {
      const dataWithFile = new FormData();
      dataWithFile.append("first_name", params.data.first_name);
      dataWithFile.append("last_name", params.data.last_name);
      dataWithFile.append("phone", params.data.phone);
      dataWithFile.append("CI_NIT", params.data.CI_NIT);
      dataWithFile.append("state", params.data.state);
      if (params.data.branch) {
        dataWithFile.append("branch", JSON.stringify(params.data.branch));
      }

      dataWithFile.append("serviceMethod", params.data.serviceMethod);
      if (params.data.picture?.rawFile) {
        dataWithFile.append("picture", await getResizedImage(params.data.picture?.rawFile, 800, "JPEG"));
      }
      if (params.data.availableServices) {
        dataWithFile.append("availableServices", JSON.stringify(params.data.availableServices));
      }

      if (params.data.servicesCommissions) {
        dataWithFile.append("servicesCommissions", JSON.stringify(params.data.servicesCommissions));
      }

      if (params.data.availability) {
        dataWithFile.append("availability", JSON.stringify(params.data.availability));
      }

      // Agregar cobrarComision
      if (params.data.cobrarComision !== undefined) {
        dataWithFile.append("cobrarComision", params.data.cobrarComision);
      }

      return await updateDataForm("employee", dataWithFile, params.data._id);
    }
  }

  if (resource === "deliverysetting") {
    if (verb === "CREATE") {
      const dataWithFile = new FormData();
      Object.entries(params.data).forEach(async ([key, value]) => {
        if (key != "image") {
          dataWithFile.append(key, value);
        }
      });
      dataWithFile.append("image", await getResizedImage(params.data.image.rawFile, 800, "PNG"));
      return await createDataForm("deliverysetting", dataWithFile);
    }

    if (verb === UPDATE) {
      const dataWithFile = new FormData();
      Object.entries(params.data).forEach(async ([key, value]) => {
        if (key != "image") {
          dataWithFile.append(key, value);
        }
      });
      if (params.data.image?.rawFile) {
        dataWithFile.append("image", await getResizedImage(params.data.image?.rawFile, 800, "PNG"));
      }
      return await updateDataForm("deliverysetting", dataWithFile, params.data._id);
    }
  }

  if (resource === "availabilityWeb") {
    if (verb === "UPDATE") {
      delete params.data.picture;
      return await update(resource, params);
    }
  }

  if (resource === "service") {
    if (verb === "CREATE" || verb === "UPDATE") {
      const dataWithFile = objectToFormData(params.data);
      if (params.data.imageURL?.rawFile) {
        dataWithFile.append("image", await getResizedImage(params.data.imageURL.rawFile, 800, "JPEG"));
      }

      if (verb === "CREATE") {
        return await createDataForm(resource, dataWithFile);
      }

      if (verb === "UPDATE") {
        dataWithFile.delete("provider");
        return await updateDataForm(resource, dataWithFile, params.data.id);
      }
    }
  }

  if (resource === "bookingBalance") {
    resource = "booking/balance";
  }

  if (resource === "adminBookingBalance") {
    if (verb === "GET_ONE") {
      resource = "booking";
    } else {
      resource = "admin/booking/balance";
    }
    if (verb === "UPDATE") {
      params.meta = {
        ...params.meta,
        customActsion: "payFee",
      };
    }
  }
  if (resource === "availability") {
    if (verb === "GET_ONE") {
      if (params.meta?.branch) {
        params.id = params.id + "?branch=" + params.meta.branch;
        return getOne(resource, params);
      } else return getOne(resource, params);
    }
  }

  if (resource === "package") {
    if (verb === "GET_ONE") {
      const profile = JSON.parse(localStorage.getItem("profile"));
      const providerId = profile?.role === "admin-sucursal" ? profile?.employer?._id : profile?._id;
      params.id = params.id + "?providerId=" + providerId;
      return getOne(resource, params);
    }
  }
  if (verb === "GET_LIST") return await getList(resource, params);
  if (verb === "GET_ONE") return getOne(resource, params);
  if (verb === "GET_MANY") return getMany(resource, params);
  if (verb === "CREATE") return create(resource, params);
  if (verb === "UPDATE") return await update(resource, params);
  if (verb === "createMany") return createMany(resource, params);
  if (verb === "DELETE") {
    return _delete(resource, params);
  }
};

// Función para verificar si un teléfono ya existe
export const checkPhoneExists = async (phone) => {
  if (!phone || phone === "0") {
    return { exists: false };
  }

  try {
    const response = await httpClient(`${apiUrl}/enterprise/customers/check-phone/${phone}`);
    return response.json;
  } catch (error) {
    console.error("Error al verificar teléfono:", error);
    throw error;
  }
};

// API WhatsApp v3 - Inicializar instancia y obtener QR
export const initializeWhatsAppInstance = async (userId) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${apiUrl}/v3/create-instance`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ ecommerce_route: userId }),
  });

  if (!response.ok) {
    throw new Error("Error al inicializar instancia de WhatsApp");
  }

  const json = await response.json();
  return json;
};

// API WhatsApp v3 - Obtener estado de instancia
export const getWhatsAppInstanceStatus = async (userId) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${apiUrl}/v3/instances/${userId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  if (!response.ok) {
    const json = await response.json();
    return json; // Devolver la respuesta aunque sea error para manejar "Instance not found"
  }

  const json = await response.json();
  return json;
};

export default handler;
